// Copyright 2017 Sorama B.V.

import { IParameterizedValueConverter2 } from "aurelia-binding-ext";

export class NumberToStringValueConverter implements IParameterizedValueConverter2<string, number, number, number> {
    public toView(value: number, decimals: number, minimumIntegerDigits = 1): string {
        // Make chaining of this converter to a NullToX ValueConverter possible and ensure it's reversible for empty string <-> NaN
        if (value === null || value === undefined || Number.isNaN(value)) {
            return null;
        }

        return value.toLocaleString(undefined, {
            minimumIntegerDigits: minimumIntegerDigits,
            maximumFractionDigits: decimals,
            useGrouping: false,
        });
    }

    public fromView(str: string, decimals?: number, minimumIntegerDigits = 1): number {
        if (str == "") return 0;
        return Number.parseFloat(str);
    }
}
